<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-app>
        <v-navigation-drawer
            v-model="$store.state.drawer"
            :clipped="$vuetify.breakpoint.lgAndUp"
            app
        >
            <v-list subheader>
                <v-list-item-group>
                    <template v-for="item in $store.state.menuItems">
                        <v-list-group
                            v-if="item.items && item.items.length != 0"
                            :key="item.id"
                            no-action
                        >
                            <template v-slot:activator>
                                <v-list-item-icon>
                                    <v-icon v-if="item.iconType === '0'">{{item.icon}}</v-icon>
                                    <v-avatar size="24px" v-else>
                                        <img :src="iconShow(item.icon)">
                                    </v-avatar>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title v-text="item.name"></v-list-item-title>
                                </v-list-item-content>
                            </template>
                            <template v-for="ite in item.items">
                                <v-list-item :key="ite.id" @click="itemClick(ite)">
                                    <v-list-item-icon>
                                        <v-icon v-if="ite.iconType === '0'">{{ite.icon}}</v-icon>
                                        <v-avatar size="24px" v-else>
                                            <img :src="iconShow(ite.icon)">
                                        </v-avatar>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="ite.name"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list-group>
                        <v-list-item v-else :key="item.id" @click="itemClick(item)">
                            <v-list-item-icon>
                                <v-icon v-if="item.iconType  === '0'">{{item.icon}}</v-icon>
                                <v-avatar size="24px" v-else>
                                    <img :src="iconShow(item.icon)">
                                </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="item.name"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-3" dark>
            <v-app-bar-nav-icon @click.stop="$store.commit('reverseDrawer')"/>
            <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
                <span class="hidden-sm-and-down">{{$vuetify.lang.t('$vuetify.custom.title')}}</span>
            </v-toolbar-title>
            <el-select
                v-5="permissionCode.search"
                v-model="stuValue"
                clearable
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="remoteMethod"
                :loading="loading"
                @change="popStudentDetail"
                @focus="focusDetail">
                <el-option
                    v-for="item in studentOptions"
                    :key="item.value+randomShow"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <v-spacer/>
           <!--  消息提示暂无功能
           <v-btn icon class="mx-2">
                <v-icon>mdi-apps</v-icon>
            </v-btn>

            <v-btn icon class="mx-2">
                <v-icon>mdi-bell</v-icon>
            </v-btn>-->

            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn icon large class="mx-2" v-on="on">
                        <v-avatar size="32px">
                            <v-img :src="require('@/assets/etoak.png')"/>
                        </v-avatar>
                    </v-btn>
                </template>
                <v-card
                    class="mx-auto"
                    width="300"
                >
                    <v-list disabled>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="title">{{ $store.state.userInfo.realname }}
                                </v-list-item-title>
                                <v-list-item-subtitle>{{ $store.state.userInfo.username }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list
                        nav
                        dense
                    >
                        <v-list-item-group color="primary">
                            <v-list-item
                                v-for="(item, i) in pullItems"
                                :key="i"
                            >
                                <v-list-item-content @click="updatePassword(item)">
                                    <v-list-item-title v-text="item.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>

                        </v-list-item-group>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list
                        nav
                        dense
                    >
                        <v-list-item-group color="primary">
                            <v-list-item @click="logout">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ $vuetify.lang.t('$vuetify.custom.menu.logOUt') }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card>
            </v-menu>
        </v-app-bar>
        <!-- 内容标签 -->
        <v-content>
            <v-container class="fill-height" fluid>
                <router-view></router-view>
                <v-dialog v-model="showDetail" max-width="1000px">
                    <score-detail v-model="showDetail" :stuDetailMsg="stuDetailMsg"></score-detail>
                </v-dialog>
                <v-dialog v-model="resetPasswordDialog" persistent max-width="500px">
                    <update-password v-model="resetPasswordDialog"></update-password>
                </v-dialog>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    // import Vue from 'vue'
    // export const eventHub = new Vue()
    import scoreDetail from '../score/score-detail'
    import updatePassword from './update-password'
    import customElement from "@/plugins/element"
    export default {
        props: {
            source: String,
        },
        data() {
            return {
                permissionCode:{
                    search:'biz:home:search',
                },
                stuDetailMsg:{
                    studentId:''
                },
                showDetail:false,
                dialog: false,
                //drawer: false,
                pullItems: [
                    {text: this.$vuetify.lang.t('$vuetify.custom.menu.setUpState'), icon: 'mdi-folder'},
                    {text: this.$vuetify.lang.t('$vuetify.custom.menu.userInformation'), icon: 'mdi-account-multiple'},
                    {text: this.$vuetify.lang.t('$vuetify.custom.menu.setUp'), icon: 'mdi-star'},
                ],
                studentOptions: [],
                stuValue: '',
                loading: false,
                resetPasswordDialog:false,
            }
        },
        computed: {
            randomShow:function(){
                return Math.floor(Math.random()*10000)
            },
            iconShow(icon) {
                return function (icon) {
                    if (icon.length == 32) {
                        return this.$file.fileDownload(icon)
                    }
                    return icon
                }
            }
        },
        methods: {
            focusDetail(){
                if(this.stuValue){
                    this.stuValue = ''
                }
            },
            updatePassword(item){
                if(item.icon == "mdi-folder"){
                    this.resetPasswordDialog = true
                }
            },
            popStudentDetail(){
                if(this.stuValue){
                    this.stuDetailMsg = Object.assign({},{studentId:this.stuValue})
                    this.showDetail = true
                }
            },
            remoteMethod(query) {
                if (query !== '') {
                    if(query.length < 2){
                        this.$message({
                            message:"请输入两个字以上",
                            type: 'warning',
                            duration:2000
                        });
                        return
                    }
                    this.loading = true
                    this.$api.student.getStudentList({name:query}).then(data => {
                        this.studentOptions = []
                        this.loading = false
                        if(data.data){
                            data.data.forEach(val => {
                                this.studentOptions.push({value:val.id,label:val.name})
                            })
                        }
                    })
                } else {
                    this.studentOptions = [];
                }
            },
            itemClick(ite) {
                this.$router.push(ite.href);
            },
            logout() {
                this.$api.sys.logout().then(data => {
                    this.$store.commit('del_token');
                    this.$router.push("/")
                })
            },
            /*菜单改为登录获取
            loadMenu() {
                this.$api.sysPermission.selectMenuList().then(data => {
                    let items = this.$utils.menu.sortMenu(data.data)
                    this.$store.commit('setMenuItems', items);
                })
            },*/
        },
        created: function () {
            //this.loadMenu(); 菜单改为登录获取
            this.$store.commit('changeDrawerOn');
        },
        components:{
            scoreDetail,updatePassword,customElement,
        }
    }
</script>
